exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd.cellAlerte .cell {\n  padding: 0!important;\n}\ntd.cellAlerte .cell div {\n  display: inline-block;\n  color: white;\n  font-size: 11px;\n  width: 100%;\n}\n.el-icon-star-on {\n  color: #409EFF;\n}\n.el-icon-more-outline {\n  color: white;\n}\n.liste-affaires .dataTable .el-table{\n  zoom: 0.9;\n}\n\n", ""]);

// exports
